import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-matchings',
  templateUrl: './help-matchings.component.html',
  styleUrls: ['./help-matchings.component.scss']
})
export class HelpMatchingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
